<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="table1"
        title="연료사용량"
        tableId="table1"
        :columns="grid1.columns"
        :gridHeight="grid1.height"
        :data="grid1.data"
        :usePaging="false"
        :hideBottom="true"
        :columnSetting="false"
        :filtering="false"
        :isExcelDown="false"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn label="저장" icon="save" v-if="!param.isFullScreen" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'daily-air-report-04',
  props: {
    param: {
      type: Object,
      default: () => ({
        reportId: '',
        isFullScreen: false,
      }),
    },
  },
  data() {
    return {
      editable: true,
      grid1: {
        columns: [
          {
            name: 'col0',
            field: 'col0',
            label: '배출시설명',
            align: 'center',
            sortable: false,
          },
          {
            name: 'col1',
            field: 'col1',
            label: '연료명',
            align: 'center',
            type: 'text',
            sortable: false,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '사용량',
            align: 'center',
            type: 'text',
            sortable: false,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '단위',
            align: 'center',
            type: 'text',
            sortable: false,
          },
        ],
        data: [],
      },
    };
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
    if (this.param.isFullScreen) {
      this.grid1.height = 'auto';
    }
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.grid1.data = [
        {
          col0: '유무기산저장시설',
          col1: 'LNG',
          col2: '22,124',
          col3: '',
          col4: '',
        },
        {
          col0: '혼합시설',
          col1: 'LNG',
          col2: '11,124',
          col3: '',
          col4: '',
        },
      ]
    },
  }
};
</script>
